const setMetaData = (data) => ({
  type: 'META_DATA',
  data: data
})

export { setMetaData }
